(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }


const mediaQuery = window.matchMedia('(max-width: 749px)')
// Check if the media query is true
if (mediaQuery.matches) {
  
  const elements = document.querySelectorAll('.accordionElement');

  elements.forEach(element =>{
      let btn = element.querySelector('.accordionHeading button');
      let icon = element.querySelector('.accordionHeading button i');
      var answer = element.lastElementChild;
      var answers = document.querySelectorAll('.accoordionElement .accordionContent');
      
      btn.addEventListener('click', ()=>{
          answers.forEach(ans =>{
              let ansIcon = ans.parentElement.querySelector('button i');
              if(answer !== ans){
                  ans.classList.add('showContent');
                  ansIcon.className = 'plus-icon';
              }
          });
          
          answer.classList.toggle('showContent');
          icon.className === 'plus-icon' ? icon.className = 'minus-icon' 
          : icon.className ='plus-icon';
      });
  });
}
  

  } catch(e) { console.error(e); }
})();
})();
